import React, {useState, useEffect} from "react";
import { LocalAudioTrack } from "twilio-video";
import { fetchSession } from "api/webservice/sessions";
import { Session } from "types";
/* import Room from "./Room"; */
import { SELECTED_AUDIO_INPUT_KEY } from "context/session/VideoProvider/constants";
import { useDevices, useVideoContext } from "hooks/session";
/* import { AudioButton } from "../Buttons"; */
import AudioLevelIndicator from "pages/Session/SessionCallPreview/AudioLevelIndicator";
import { AudioDropdown } from "components";
import { Box, Text } from "@chakra-ui/react";

const AudioSettingsPanel: React.FC = () => {
  const { room, localTracks, getLocalAudioTrack, onError } = useVideoContext();
  const localParticipant = room?.localParticipant;
  const { audioInputDevices } = useDevices();
  const track = localTracks.find(
    track => track.kind === "audio"
  ) as LocalAudioTrack;
  const [mute, setMute] = useState(track?.isEnabled);

  //maybe also use this to swap in the morphed voices?
  const replaceTrack = (newDeviceId: string) => {
    window.localStorage.setItem(SELECTED_AUDIO_INPUT_KEY, newDeviceId);
    //this seems to control actual audio output through speakers
    /* track.restart({ deviceId: { exact: newDeviceId } }); */

    getLocalAudioTrack(newDeviceId)
    .then((track: LocalAudioTrack) => {
      localParticipant?.publishTrack(track);
    })
    .catch(onError);

    //this seems to help but i'm not sure why, commenting it out doesn't seem to update the audio output correctly
    if (mute) {
      console.log("mute: ", mute);
      track.disable();
      setMute(true);
    };
  
  };

  return(
    <>
      {audioInputDevices.length > 1 && (
        <AudioDropdown deviceCategory="Audio Options" callback={replaceTrack} deviceList={audioInputDevices}/>
      )}
      <Box mt="25px">
        <Text>Audio Test</Text>
      </Box>
      <AudioLevelIndicator audioTrack={track}/>
    </>
  );
};

export default AudioSettingsPanel;